import { BrowsedJobDetailsContainerStyled } from '../../../components/TechnicianBrowsedJobDetails/style';
import { Typography } from '../../../designComponents';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { humanReadableDate } from '../../../utils';

type Props = {
  fullName: string;
  startingDate: string;
  endDate: string;
  experience: string;
  designApproach: string;
  riskAssessment: string;
  specification: string;
  emailAddress: string;
};

const PdfInformation = ({
  designApproach,
  endDate,
  experience,
  fullName,
  riskAssessment,
  specification,
  startingDate,
  emailAddress,
}: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        TECHNICIAN DETAILS
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="userName">
          <Typography className="title" fontColor="dark">
            Technician name :{' '}
          </Typography>
          <Typography className="value">{fullName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userType">
          <Typography className="userEmail" fontColor="dark">
            Email Address :{' '}
          </Typography>
          <Typography className="value">{emailAddress}</Typography>
        </InfoRowStyled>

        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            Starting Date :
          </Typography>
          <Typography>{humanReadableDate(startingDate)}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            Ending Date :
          </Typography>
          <Typography>{humanReadableDate(endDate)}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            Experiencce :
          </Typography>
          <Typography>{experience}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            Work Approach :
          </Typography>
          <Typography>{designApproach}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            Risk Assessment :
          </Typography>
          <Typography>{riskAssessment}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            Specification :
          </Typography>
          <Typography>{specification}</Typography>
        </InfoRowStyled>
        <InfoRowStyled className="userAddress">
          <Typography className="title" fontColor="dark">
            Design Approach :
          </Typography>
          <Typography>{designApproach}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default PdfInformation;
